import { useLazyQuery } from "@apollo/client";

import { BusinessPartnersQuery } from "../../../graphql/deliveryService/queries/businessPartners";
import { BusinessPartnersQuery as BusinessPartnersQueryType } from "../../../models/autogenerated-deliveryService-gql/graphql";

type BusinessPartner =
  BusinessPartnersQueryType["businessPartners"]["data"][number];
type PageInfo = BusinessPartnersQueryType["businessPartners"]["pageInfo"];

interface UseBusinessPartnersQueryProps {
  dataAction: (collection: {
    data: BusinessPartner[];
    pageInfo: PageInfo;
  }) => void;
}

const useBusinessPartnersQuery = (props: UseBusinessPartnersQueryProps) => {
  const { dataAction } = props;

  const [query] = useLazyQuery(BusinessPartnersQuery, {
    onCompleted: (data) => {
      dataAction({
        data: data?.businessPartners?.data || [],
        pageInfo: data?.businessPartners?.pageInfo || {
          hasNextPage: false,
          hasPreviousPage: false,
        },
      });
    },
    onError: (error) => {
      console.error("Error fetching business partners:", error);
    },
  });

  return [query] as const;
};

export default useBusinessPartnersQuery;
